import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Save = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4167 4.25C8.78117 4.25 7.21265 4.8997 6.05617 6.05617C4.8997 7.21265 4.25 8.78117 4.25 10.4167V39.5833C4.25 41.2188 4.8997 42.7873 6.05617 43.9438C7.21265 45.1003 8.78116 45.75 10.4167 45.75H39.5833C41.2188 45.75 42.7873 45.1003 43.9438 43.9438C45.1003 42.7873 45.75 41.2188 45.75 39.5833V16.6667C45.75 16.1362 45.5393 15.6275 45.1642 15.2525L34.7475 4.83579C34.3725 4.46071 33.8638 4.25 33.3333 4.25H10.4167ZM10.4167 8.25C9.84203 8.25 9.29093 8.47827 8.8846 8.8846C8.47827 9.29093 8.25 9.84203 8.25 10.4167V39.5833C8.25 40.158 8.47827 40.7091 8.8846 41.1154C9.29093 41.5217 9.84203 41.75 10.4167 41.75H12.5834V27.0833C12.5834 25.9787 13.4788 25.0833 14.5834 25.0833H35.4167C36.5213 25.0833 37.4167 25.9787 37.4167 27.0833V41.75H39.5833C40.158 41.75 40.7091 41.5217 41.1154 41.1154C41.5217 40.7091 41.75 40.158 41.75 39.5833V17.4951L32.5049 8.25H16.5834V14.6667H31.25C32.3546 14.6667 33.25 15.5621 33.25 16.6667C33.25 17.7712 32.3546 18.6667 31.25 18.6667H14.5834C13.4788 18.6667 12.5834 17.7712 12.5834 16.6667V8.25H10.4167ZM33.4167 41.75H16.5834V29.0833H33.4167V41.75Z"
        fill={color}
      />
    </svg>
  )
}
